<template>
  <div data-test-id="fire-button">
    <q-circular-progress
      v-if="orderItem.state == 'draft' && !stopped && !orderItem.hasDueTime"
      show-value
      :thickness="0.05"
      class="text-negative"
      :model-value="100 - progressValue"
      size="35px"
      color="negative"
      @click.stop="stop()"
    >
      <q-icon
        name="publish"
        size="sm"
      />
    </q-circular-progress>
    <q-btn
      v-else-if="orderItem.state == 'draft' && !orderItem.hasDueTime"
      icon="publish"
      color="negative"
      size="md"
      round
      :loading="firing"
      dense
      outline
      @click.stop="fire()"
    />
    <q-btn
      v-else-if="orderItem.dueTime == null && orderItem.hasDueTime && currentSite.usePickPrepWaitAndFire && orderItem.placed"
      icon="timer"
      color="warning"
      size="md"
      round
      dense
      outline
      @click.stop="$refs.deliveryModifierDialog.show()"
    />
    <div v-else-if="orderItem.placed && orderItem.hasDueTime && orderItem.pickPrepPrintingStatus == 'none'">
      <q-btn
        icon="schedule"
        color="negative"
        size="md"
        class="q-mt-sm"
        round
        :loading="firing"
        dense
        @click.stop="fire()"
      />
      <div class="text-caption text-grey">
        {{ orderItem.preparationPrintsAt ? orderItem.preparationPrintsAt.relativeTime({ compact: true }) : '' }}
      </div>
    </div>
    <q-btn
      v-else-if="orderItem.placed && orderItem.pickPrepPrintingStatus == 'waiting'"
      icon="check"
      color="positive"
      :loading="true"
      size="md"
      disable
      round
      dense
      outline
    />
    <q-btn
      v-else-if="orderItem.state == 'voided' && orderItem.pickPrepPrintingStatus == 'waiting'"
      icon="check"
      color="negative"
      :loading="true"
      size="md"
      disable
      round
      dense
      outline
    />
    <q-btn
      v-else-if="orderItem.placed && orderItem.pickPrepPrintingStatus == 'success'"
      icon="check"
      color="positive"
      size="md"
      disable
      round
      dense
      outline
      @click.stop="stopped = true"
    />
    <q-btn
      v-else-if="orderItem.state == 'voided' && orderItem.pickPrepPrintingStatus == 'success'"
      icon="check"
      color="negative"
      size="md"
      disable
      round
      dense
      outline
      @click.stop="stopped = true"
    />
    <delivery-modifier-dialog
      v-if="currentSite.usePickPrepWaitAndFire"
      ref="deliveryModifierDialog"
      :order="order"
    />
  </div>
</template>

<script>

import DeliveryModifierDialog from 'src/modules/register/components/DeliveryModifierDialog'

export default {
  name: 'FireButton',
  components: {
    DeliveryModifierDialog
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    orderItems: {
      type: Array,
      required: true
    },
    autoPlace: {
      type: Boolean,
      required: false,
      default: false
    },
    countDownSeconds: {
      type: Number,
      required: false,
      default: 5
    }
  },
  emits: ['place-order'],
  data () {
    return {
      progressValue: 0,
      fired: false,
      stopped: false,
      firing: false
    }
  },
  computed: {
    orderItem () {
      return this.orderItems[0]
    }
  },
  configuration: ['currentSite'],
  mounted () {
    if (this.autoPlace && this.orderItem.state === 'draft') {
      this.intervalId = setInterval(() => {
        const newValue = this.progressValue + 100 / this.countDownSeconds / 10
        this.progressValue = Math.max(newValue, 0)
        if (this.progressValue === 100) {
          this.fire()
          clearInterval(this.intervalId)
        }
      }, 100)
    } else {
      this.stopped = true
    }
  },
  unmounted () {
    clearInterval(this.intervalId)
  },
  methods: {
    stop () {
      clearInterval(this.intervalId)
      this.stopped = true
    },
    async fire () {
      this.firing = true
      this.$emit('place-order', 'Print')
      this.firing = false

      this.fired = true
    }
  }
}

</script>
